module.exports = __webpack_public_path__ + "static/media/Profile.ef83c210.jpeg";